import { useApi } from './apiService';

export const useTenant = () => {
  const api = useApi();

  const getTenant = async (tenantID: string) => {
    try {
      const response = await api.get(`tenantservice/Tenant/dashboard/tenants/${tenantID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tenant:', error);
      throw error;
    }
  };

  return { getTenant };
};

export const useAllGroups = () => {
  const api = useApi();

  const getGroups = async (tenantID: string) => {
    try {
      const response = await api.get(`tenantservice/TenantGroup/${tenantID}/groups`);
      return response.data;
    } catch (error) {
      console.error('Error fetching groups:', error);
      throw error;
    }
  };

  return { getGroups };
};

export const useSeverityRedirection = () => {
  const api = useApi();

  const getSeverityRedirection = async (
    tenantID: string,
    payload: Record<string, any>,
    patchType: 'OSUpdate' | 'ThirdPartySoftware' = 'ThirdPartySoftware',
  ) => {
    try {
      const endpoint =
        patchType === 'OSUpdate'
          ? `patchreposervice/SoftwarePatch/${tenantID}/os-update-severity-heatmap`
          : `patchreposervice/SoftwarePatch/${tenantID}/severity-heatmap`;
      const response = await api.post(endpoint, payload);
      return response;
    } catch (error) {
      console.error('Error fetching severity redirection:', error);
      throw error;
    }
  };

  return { getSeverityRedirection };
};

export const useRemedForOSupdate = () => {
  const api = useApi();

  const getRemedForOSupdate = async (tenantId: string, payload: Record<string, any>) => {
    try {
      // const response = await api.post(`patchcenterservice/RemediationPlan/${OSupdateID}/create-remediation-plan-for-osupdate`, payload);
      const response = await api.post(`patchcenterservice/RemediationPlan/${tenantId}/create-remediation-plan-for-osupdate`, payload);
      return response;
    } catch (error) {
      console.error('Error fetching severity redirection:', error);
      throw error;
    }
  };

  return { getRemedForOSupdate };
};

export const useThirdPartyupdate = () => {
  const api = useApi();

  const getThirdPartyupdate = async (tenantId: string, payload: Record<string, any>) => {
    try {
      const response = await api.post(
        `patchcenterservice/RemediationPlan/${tenantId}/create-remediation-plan-for-packageidentifier`,
        payload,
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching severity redirection:', error);
      throw error;
    }
  };

  return { getThirdPartyupdate };
};
